// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__M3BYc","gfeWrapper":"CalendarEvent_gfeWrapper__2qeyW"};